export default __webpack_public_path__ + "static/rocket-d3b28754fb6b6b01f644a083204f3553.png";